if (!customElements.get('comely-mobile-menu')) {
  customElements.define(
    'comely-mobile-menu',
    class ComelyMobileMenu extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleClick);

        this.dialog = this.closest('dialog');
        this.dialog?.addEventListener('close', this.resetPanels);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.dialog?.removeEventListener('close', this.resetPanels);
      }

      handleClick = (event) => {
        const backButton = event.target.closest('[data-comely-menu-back]');
        if (!backButton || !this.contains(backButton)) return;

        const openPanel = backButton.closest('details[open]');
        if (!openPanel) return;

        const summary = openPanel.querySelector(':scope > summary');
        openPanel.removeAttribute('open');
        summary?.focus({ preventScroll: true });
      };

      resetPanels = () => {
        this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
      };
    }
  );
}
